if (!customElements.get('pms-lightbox')) {
  customElements.define(
    'pms-lightbox',
    class PmsLightbox extends HTMLElement {
      constructor() {
        super();
        this.mainSwiper = null;
        this.thumbsSwiper = null;
        this.initialized = false;
        this.hintTimer = null;
      }

      connectedCallback() {
        document.body.appendChild(this);

        this.mainEl = this.querySelector('[data-pms-lightbox-main]');
        this.thumbsEl = this.querySelector('[data-pms-lightbox-thumbs]');
        this.zoomHint = this.querySelector('[data-pms-zoom-hint]');
        this.zoomHintText = this.querySelector('[data-pms-zoom-hint-text]');

        const isTouch =
          'ontouchstart' in window || navigator.maxTouchPoints > 0;
        if (isTouch && this.zoomHintText) {
          this.zoomHintText.textContent = 'Pinch or double tap to zoom';
        }

        this.querySelectorAll('[data-pms-lightbox-close]').forEach((el) => {
          el.addEventListener('click', () => this.close());
        });

        document.addEventListener('keydown', (e) => {
          if (
            e.key === 'Escape' &&
            this.classList.contains('pms-lightbox--open')
          ) {
            this.close();
          }
        });

        window.openProductLightbox = (index) => this.open(index);
      }

      initSwipers() {
        if (this.initialized || typeof Swiper === 'undefined') return;

        this.thumbsSwiper = new Swiper(this.thumbsEl, {
          slidesPerView: 'auto',
          spaceBetween: 8,
          freeMode: true,
          watchSlidesProgress: true,
        });

        this.mainSwiper = new Swiper(this.mainEl, {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: true,
          zoom: { maxRatio: 3 },
          keyboard: { enabled: true, onlyInViewport: false },
          navigation: {
            nextEl: this.querySelector('[data-pms-lightbox-next]'),
            prevEl: this.querySelector('[data-pms-lightbox-prev]'),
          },
          thumbs: { swiper: this.thumbsSwiper },
        });

        this.mainSwiper.on('slideChange', () => this.showZoomHint());
        this.initialized = true;
      }

      showZoomHint() {
        if (!this.zoomHint) return;
        clearTimeout(this.hintTimer);
        this.zoomHint.classList.add('is-visible');
        this.hintTimer = setTimeout(() => {
          this.zoomHint.classList.remove('is-visible');
        }, 2500);
      }

      getMainRealSlideCount() {
        if (!this.mainEl) return 0;
        return this.mainEl.querySelectorAll(
          '.swiper-slide:not(.swiper-slide-duplicate)',
        ).length;
      }

      normalizeRealIndex(index) {
        const total = this.getMainRealSlideCount();
        let realIndex = Number(index);
        if (!Number.isFinite(realIndex)) realIndex = 0;
        if (total <= 0) return 0;
        return Math.max(0, Math.min(realIndex, total - 1));
      }

      goToRealIndex(realIndex) {
        if (!this.mainSwiper) return;
        const loopEnabled = Boolean(this.mainSwiper.params?.loop);
        if (loopEnabled && typeof this.mainSwiper.slideToLoop === 'function') {
          this.mainSwiper.slideToLoop(realIndex, 0, false);
        } else {
          this.mainSwiper.slideTo(realIndex, 0, false);
        }
        this.mainSwiper.update();
        if (this.thumbsSwiper) this.thumbsSwiper.update();
      }

      open(index) {
        this.initSwipers();
        this.classList.add('pms-lightbox--open');
        this.setAttribute('aria-hidden', 'false');
        document.body.classList.add('lightbox-open');

        if (this.mainSwiper) {
          const realIndex = this.normalizeRealIndex(index);

          requestAnimationFrame(() => {
            this.goToRealIndex(realIndex);
          });
        }

        this.showZoomHint();
      }

      close() {
        this.classList.remove('pms-lightbox--open');
        this.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('lightbox-open');
        this.mainEl
          .querySelectorAll('video')
          .forEach((videoElement) => videoElement.pause());
      }
    },
  );
}
